
const init = () => {

    document.querySelectorAll('[data-modal-toggle]').forEach((item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            let modal = item.getAttribute('data-modal-toggle');
            let modalEl = document.querySelector(`#${modal}`);

            if(modalEl){
                modalEl.classList.toggle('is-close');
            }
        });
    });
    

};

export default { init };